import { render, staticRenderFns } from "./TagsToChart.vue?vue&type=template&id=3ad3eaa2"
import script from "./TagsToChart.vue?vue&type=script&lang=js"
export * from "./TagsToChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports